import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { trackByEventId } from 'angular-calendar/modules/common/util';
import { bool } from 'aws-sdk/clients/signer';

@Component({
  selector: 'app-delete-confirm-modal',
  templateUrl: './delete-confirm-modal.component.html',
  styleUrls: ['./delete-confirm-modal.component.scss']
})
export class DeleteConfirmModalComponent implements OnInit {
  isDeleteModal: boolean = true;
  isUserDisplay = false
  listOfJobRadio = []
  // private defaultSelected ="job Archive"
  private selection;

  // isJobDisplay=false
  jobData = false
  jobConfirmActive = false
  displayData
  loading: boolean = false;
  isDuplicate = false
  isArchiveStaff = false
  isPPEKit = false
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DeleteConfirmModalComponent>) { }

  ngOnInit() {
    console.log("what is in delete model", this.data);

    console.log(typeof this.data == 'object');
    if (typeof this.data == 'object') {
      this.isDeleteModal = false
      // console.log("object")
    }

    if (this.data && this.data.isDelete) {
      this.isUserDisplay = true
      this.displayData = this.data.msg
      // console.log("if")
    } else {

      if (this.data == "Archive Jobs" || this.data == "Unarchive Jobs") {
        this.jobData = true;
      }
      // else{
      this.isUserDisplay = false
      // this.isJobDisplay=false
      // }
      // console.log("else",this.d)
    }


    if (this.data == 'Unarchive Jobs') {
      this.listOfJobRadio.push('Unarchive')
      this.listOfJobRadio.push('Delete')

    } else {
      this.listOfJobRadio.push('Archive')
      this.listOfJobRadio.push('Delete')
    }

    if (this.data && this.data.isDuplicate) this.isDuplicate = true

    if (this.data && this.data.isArchiveStaff) this.isArchiveStaff = true
    if (this.data && this.data.isPPEKit) this.isPPEKit = true


    console.log("Data========>", this.data);
  }
  confirm(value) {
    this.loading = true
    console.log("fins refrance =====>", this.dialogRef)
    // console.log('value', value);
    this.dialogRef.close(value)

  }

  confirmjob(value) {
    let obj = {
      confirm: value,
      selectRadio: this.selection
    }
    console.log("this.selection", this.selection)
    console.log("fins refrance =====>", this.dialogRef)
    // console.log('value', value);
    this.dialogRef.close(obj)
  }
  multiJObDelete(data) {


    this.selection = data;
    if (this.selection != undefined) {
      this.jobConfirmActive = true
    }
    console.log("current selecton value ========>", data)
    console.log("select value", this.selection)
  }
}
